import { createReducer } from '@reduxjs/toolkit';
import { initialAuthState as initialState } from './state';
import * as actions from './action';
import { setNestedField } from '../utils';

export default createReducer(initialState(), (builder) => {
  builder
    .addCase(actions.setAuth, (state, { payload: { field, value } }) => {
      setNestedField(state, field, value);
    })
    .addCase(actions.setToken, (state, { payload }) => {
      state.token = payload;
    })
    .addCase(actions.setProfile, (state, { payload }) => {
      state.profile = payload;
    })
    .addCase(actions.authenticated, (state) => {
      state.authenticated = true;
    })
    .addCase(actions.resetAuth, (state) => {
      return initialState();
    });
});
